/* eslint-disable no-new */
import 'svgxuse';
import 'mdn-polyfills/Element.prototype.closest';
import objectFitImages from 'object-fit-images';

import MainNav from './modules/MainNav';
import Slider from './modules/Slider';
import HeroSlider from './modules/HeroSlider';
import ContentSlider from './modules/ContentSlider';
import SocialSlider from './modules/SocialSlider';
import ScrollToElement from './modules/ScrollToElement';
import PositionStickyVertical from './modules/PositionStickyVertical';
import PositionStickyHorizontal from './modules/PositionStickyHorizontal';
import Overlay from './modules/Overlay';
import FormValidator from './modules/FormValidator';
import FormSelectDependency from './modules/FormSelectDependency';
import FormSubject from './modules/FormSubject';

import StickyFooter from './partials/StickyFooter';

new MainNav();
new Slider();
new HeroSlider();
new ContentSlider();
new SocialSlider();
new ScrollToElement();
new StickyFooter();
new PositionStickyVertical();
new PositionStickyHorizontal();
new Overlay();
new FormValidator();
new FormSubject();
new FormSelectDependency();

objectFitImages('[data-object-fit]');
// eslint-disable-next-line
import style from '../scss/ero.scss';
